import React,{useRef,useEffect} from 'react';

import { useParams } from 'react-router-dom';
// the hook
import { observer } from 'mobx-react';
import {useTranslation} from 'react-i18next';
import { AndroidOutlined, AppleOutlined, CommentOutlined, ThunderboltOutlined, CustomerServiceOutlined, ToolOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined } from '@ant-design/icons';
import {Carousel,Tabs, Button } from 'antd';
import { http, addVisitLog, history } from 'libs';
import Login from '../login/index';
import gStore from 'store';

import style from './index.module.less'
import banner_logo from './banner_logo.png';
import banner_drop from './banner_drop.png';
import water_drop from './water_drop.png';
import advantage1 from './advantage1.png';
import advantage2 from './advantage2.png';
import advantage3 from './advantage3.png';
import card_digitize from './card_digitize.png';
import card_control from './card_control.png';
import card_answer from './card_answer.png';
import card_synergia from './card_synergia.png';
import banner_title from './banner_title.png';
import product1 from './product1.png';
import product2 from './product2.png';
import product3 from './product3.png';
import product4 from './product4.png';
import product5 from './product5.png';
import product6 from './product6.png';
import product7 from './product7.png';
import server1 from './server_1.png';
import server2 from './server_2.png';
import server3 from './server_3.png';
import server4 from './server_4.png';

export default observer(function () {
  const {t, i18n} = useTranslation();// {t('')}

  // const searchParams = new URLSearchParams(window.location.search);
  // // let params = searchParams.get('params')?.replaceAll(" ","+");
  // const sign = searchParams.get('sign');
  // const time = searchParams.get('time');
  // const userEmail = searchParams.get('userEmail');
  // const userName = searchParams.get('userName');
  // const companyType = searchParams.get('companyType');
  // if (sign) {
  //   http.post('/javaApi/user/thirdPartyLogin',{
  //     sign,time,userEmail,companyType,userName
  //   })
  //   .then( res => {
  //     const userInfo=res.data.result;
  //     localStorage.setItem('token', userInfo['token']);
  //     localStorage.setItem('nickname', userInfo['name']);
  //     localStorage.setItem('userInfo', JSON.stringify(userInfo));
  //     history.push('/goods')
  // }).catch( err => {
  //   localStorage.removeItem('token');
  //   localStorage.removeItem('nickname'); 
  //   localStorage.removeItem('userInfo'); 
  //   history.push('/goods')
  // })
  // }

  const startSelection = ()=>{
    // if(area === 'banner'){
      history.push('/home');
      // return
    // }
    // addVisitLog({
    //   pageName: '开始选品',
    //   fromPageUrl: window.referrerUrl,
    //   pageUrl:`${window.location.origin}${history.location.pathname}`,
    //   eventCode: 'ClickStartSelect',
    //   eventName: "开始选品",
    // })
    // history.push('./goods');
  }

  const startExperience = ()=>{
    addVisitLog({
      pageName: '开始体验',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: 'ClickStartExperience',
      eventName: "开始体验",
    })
    history.push('./goods');
  }

  const showServiceIntroduce = ()=>{
    addVisitLog({
      pageName: '查看服务介绍',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: 'ShowServiceIntroduce',
      eventName: "查看服务介绍",
    })
    history.push('./business');
  }


  useEffect(()=>{
    return ()=>{
      gStore.isLogin = false;
    }
  },[])
  
  let token = localStorage.getItem('token');
  return (
    <div className={style.homeContainer}>
      <div className='home_banner'>
        <div className="banner_logo">
          <img src={banner_logo} alt="" />
        </div>
        <div className="banner_drop">
          <img className='banner_drop' src={banner_drop} alt="" />
          <img className='water_drop' src={water_drop} alt="" />
          <div className='login_modal'>
            {<Login/>}
          </div>
        </div>
        <div className='handle_btn' onClick={()=>startSelection()}>{'点击进入首页 >'}</div>
      </div>
      {/* <div className='marginLine'></div>
      <div className='home_banner2'>
        <div className='banner2_content'>
          <div className='banner2_title'><img src={banner_title} alt="" /></div>
          <div className='banner2_desc banner2_title_desc'>1零设备资产启动临床试验</div>
          <div className='banner2_desc'>
            除搜索查询产品，完成询价和下单（租赁或采买）功能外，平台可在线实现设备管理，如：提供用户所需设备信息、设备流转记录、计量证书下载、租期和校准证书效期提醒等功能。
          </div>
          <div className='banner2_btn'>
            <Button className='bannerBtn' type="primary" shape="round" ghost onClick={()=>startSelection()}>开始选品</Button>
          </div>
        </div>
        <div className='carousel'>
          <div className='product_show_two'>
            <div className='product_container'>
              <img className='productImg1' src={product1} alt="" />
            </div>
            <div className='product_container'>
              <img className='productImg2' src={product2} alt="" />
            </div>
          </div>
          <div className='product_show_three'>
            <div className='product_container'>
              <img className='productImg3' src={product3} alt="" />
            </div>
            <div className='product_container'>
              <img className='productImg4' src={product4} alt="" />
            </div>
            <div className='product_container'>
              <img className='productImg5' src={product5} alt="" />
            </div>
          </div>
          <div className='product_show_two'>
            <div className='product_container'>
              <img className='productImg6' src={product6} alt="" />
            </div>
            <div className='product_container'>
              <img className='productImg7' src={product7} alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className='marginLine'></div>
      <div className="home_advantage">
        <div className='home_advantage_title'>
          <h3>全方位服务</h3>
        </div>
        <div className='home_advantage_content'>
          <div className='advantage_item'>
            <div className='advantage_item_title'>租</div>
            <div className='advantage_desc2'>租赁服务，让申办方0设备资产快速启动临床试验。</div>
            <div className='advantage_item_img'>
              <img src={advantage1} alt="" />
            </div>
            <div className='advantage_desc3'>租赁范围：<span className='blod'>冰箱、离心机、恒温箱、输液泵、温湿度记录仪、心电图机</span>等临床试验常用设备。</div>
          </div>
          <div className='advantage_item'>
            <div className='advantage_item_title'>售</div>
            <div className='advantage_desc2'>一站式供给服务，满足申办方个性化的采买需求。</div>
            <div className='advantage_item_img'>
              <img src={advantage2} alt="" />
            </div>
            <div className='advantage_desc3'>服务范围：<span className='blod'>通用设备、耗材、低值易耗品。</span></div>
          </div>
          <div className='advantage_item'>
            <div className='advantage_item_title'>管</div>
            <div className='advantage_desc2'>设备管理服务，助力申办方的资管合规、规避风险、降本增效。</div>
            <div className='advantage_item_img'>
              <img src={advantage3} alt="" />
            </div>
            <div className='advantage_desc3'>服务范围：<span className='blod'>设备全国校准、设备转运、设备仓储和销毁服务。</span></div>
          </div>
        </div>
        <div className='home_advantage_btn_container'>
            <Button className='home_advantage_btn' type="primary" shape="round" ghost onClick={()=>startExperience()}>开始体验</Button>
          </div>
      </div>
      <div className='marginLine'></div>
      <div className='home_banner3'>
        <div className='home_title'>
          <h3>“无忧“服务体系</h3>
        </div>
        <div className='home_card_list'>
          <div className='home_card_item'>
            <div className='home_card_item_title'>全程数字化</div>
            <div className='home_card_item_desc'>所有采买和租赁的设备信息可实时查看、下载和追溯。项目间设备的流转信息和服务信息全程无断点。</div>
            <img src={server1} alt="" className='server_bgImg'/>
          </div>
          <div className='home_card_item'>
            <div className='home_card_item_title'>风控/预警</div>
            <div className='home_card_item_desc'>系统根据申办方需求自动发送设备校准到期提醒、租赁到期提醒，规避过期风险。</div>
            <img src={server2} alt="" className='server_bgImg'/>
          </div>
          <div className='home_card_item'>
            <img src={server3} alt="" className='server_bgImg'/>
          </div>
          <div className='home_card_item bg_white'>
            <div className='home_card_item_title black_text'>极速响应</div>
            <div className='home_card_item_special_des marginT48'>
              <span className='import_text'>咨询/报价：</span>
              <span>专属客服“1H“报价，协助选型、技术咨询！</span>
            </div>
            <div className='home_card_item_special_des'>
              <span className='import_text'>发货：</span>
              <span>优选设备充足备货，完善的紧急替换方案！</span>
            </div>
            <div className='home_card_item_special_des'>
              <span className='import_text'>售后：</span>
              <span>1小时响应，8小时提供解决方案！</span>
            </div>
          </div>
          <div className='home_card_item bg_white'>
            <div className='home_card_item_title black_text'>降本增效</div>
            <div className='home_card_item_special_des marginT48'>
              <span className='import_text'>租赁服务：</span>
              <span>共享经济模式，使申办方成本更低、浪费更小、更环保！</span>
            </div>
            <div className='home_card_item_special_des paddingLR38'>
              <span className='import_text'>多业务模块组合：</span>
              <span>个性化服务，根据申办方具体情况，提供定制服务方案，更大限度使用资源！</span>
            </div>
          </div>
          <div className='home_card_item'>
            <img src={server4} alt="" className='server_bgImg'/>
          </div>
        </div>
        <div className='home_banner3_btn_container'>
            <Button className='home_banner3_btn' type="primary" shape="round" ghost onClick={()=>showServiceIntroduce()}>查看服务介绍</Button>
        </div>
      </div>
      <div className='marginLine'></div> */}
    </div>
  )
})
